export default __webpack_public_path__ + "static/stacks-9ca7e02c2637195b07ca54a21de57d30.svg";